'use client';

import { useEffect } from 'react';

const HEADER_HEIGHT = 89;

/**
 * Fixes hash-based scroll positioning on initial page load.
 *
 * The browser scrolls to #hash before images/fonts finish loading,
 * then layout shift pushes the target out of view. This component
 * watches for layout changes and keeps correcting the scroll position
 * until the page stabilises.
 */
export const HashScrollFix = () => {
  useEffect(() => {
    const hash = window.location.hash;
    if (!hash) return;

    const el = document.querySelector(hash);
    if (!el) return;

    let rafId: number;
    let lastTop = -1;
    let stableCount = 0;

    const correct = () => {
      const top = el.getBoundingClientRect().top + window.scrollY - HEADER_HEIGHT;

      // Only scroll if position has changed
      if (Math.abs(top - lastTop) > 2) {
        window.scrollTo({ top, behavior: 'instant' });
        stableCount = 0;
      } else {
        stableCount++;
      }

      lastTop = top;

      // Stop once position has been stable for 30 frames (~500ms)
      if (stableCount < 30) {
        rafId = requestAnimationFrame(correct);
      }
    };

    rafId = requestAnimationFrame(correct);

    return () => cancelAnimationFrame(rafId);
  }, []);

  return null;
};
